// Auto-generated file
export default {
  'atomic-recs-error': async () => await import('./atomic-recs-error/atomic-recs-error.js'),
  'atomic-recs-interface': async () => await import('./atomic-recs-interface/atomic-recs-interface.js'),
  'atomic-recs-list': async () => await import('./atomic-recs-list/atomic-recs-list.js'),
  'atomic-recs-result': async () => await import('./atomic-recs-result/atomic-recs-result.js'),
  'atomic-recs-result-template': async () => await import('./atomic-recs-result-template/atomic-recs-result-template.js'),
} as Record<string, () => Promise<unknown>>;

export type * from './index.js';